import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";
import { WhatsappButton } from "./components/whatsappButton";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Granite from "./pages/Granite";
import Contact from "./pages/Contact";
import JsonData from "./data/data.json";
import "./App.css";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

const App = () => (
  <BrowserRouter>
    <ScrollToTop />
    <Navigation data={JsonData.Company} />
    <Routes>
      <Route path="/" element={<Home data={JsonData} />} />
      <Route path="/about" element={<About data={JsonData} />} />
      <Route path="/products" element={<Products data={JsonData} />} />
      <Route path="/granite" element={<Granite data={JsonData} />} />
      <Route path="/contact" element={<Contact data={JsonData} />} />
      <Route path="*" element={<Home data={JsonData} />} />
    </Routes>
    <Footer data={JsonData} />
    <WhatsappButton data={JsonData.Contact} />
  </BrowserRouter>
);

export default App;
